import { useContext } from "react";
import { MicroserviceEventsContext } from "./MicroserviceEventsContext";

export const useMicroserviceEvents = () => useContext(MicroserviceEventsContext);